import React, {useEffect, useState} from 'react';
import {Box, Pressable, Typography} from '@ttx/design-system';

interface TabViewProps {
  activeRelease?: number;
  isMobile?: boolean;
  tabData: TabData[];
  isStudioPage?: boolean;
}

type TabData = {
  component: any;
  title: string;
};

export const TabViewInfo: React.FC<TabViewProps> = ({
  activeRelease,
  isMobile,
  tabData,
  isStudioPage = false,
}) => {
  const [activeTab, setActiveTab] = useState<number>(activeRelease || 0);
  const [hovered, setHovered] = useState<number | null>(null);

  useEffect(() => {
    if (!activeRelease) return;
    setActiveTab(activeRelease);
  }, [activeRelease]);

  if (!tabData.length) {
    return null;
  }

  return (
    <>
      <Box
        flexDirection="row"
        borderColor="grey32"
        borderStyle="solid"
        borderTopWidth="zero"
        borderRightWidth="zero"
        borderLeftWidth="zero"
        borderBottomWidth="one"
        marginTop="eight"
        marginBottom="zero"
      >
        {tabData.map((e, i) => {
          return (
            <Pressable
              key={e.title}
              onHoverIn={() => setHovered(i)}
              onHoverOut={() => setHovered(null)}
              onPress={() => setActiveTab(i)}
            >
              <Box
                borderColor="outlines"
                borderStyle="solid"
                borderTopWidth="zero"
                borderRightWidth="zero"
                borderLeftWidth="zero"
                borderBottomWidth={i === activeTab ? 'two' : 'zero'}
                marginTop="four"
                marginLeft="four"
                marginRight="four"
                marginBottom="zero"
                // eslint-disable-next-line no-nested-ternary
                height={isMobile ? '28px' : isStudioPage ? undefined : '70px'}
              >
                <Typography
                  fontSize={isMobile ? 'm' : 'heroSmall'}
                  color={
                    i === activeTab || hovered === i ? 'textDefault' : 'textLow'
                  }
                  css={
                    isStudioPage
                      ? {
                          color: 'var(--studio-primaryText)',
                          'font-size': '30px',
                        }
                      : {}
                  }
                >
                  {e.title}
                </Typography>
              </Box>
            </Pressable>
          );
        })}
      </Box>
      <Box>{tabData[activeTab].component}</Box>
    </>
  );
};
